<template>
  <div>
    <b-card :title="cardTitle">
      <b-overlay :show="isLoading">
        <!-- ESTE É O COMPONENTE DO GRÁFICO -->
        <VueApexCharts
          v-if="chartReady"
          type="line"
          height="350"
          :options="chartOptions"
          :series="chartSeries"
        />
        <div
          v-else
          class="text-center p-5"
        >
          <h5>Sem dados para exibição</h5>
        </div>
        <!-- ----------------------------- -->
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import axios from '@/../axios-auth'
import { mapGetters } from 'vuex'

export default {
  name: 'FaturamentoMensalGrafico',
  components: {
    BCard,
    BOverlay,
    VueApexCharts,
  },
  data() {
    return {
      isLoading: false,
      dadosGraficos: false,
      totalFaturamentoDia: 0,
      chartSeries: [
        { name: 'Q° de Clientes', type: 'column', data: [], color: '#ff6900' },
        { name: 'Q° de Parcelas', type: 'column', data: [], color: '#6610f2' },
        { name: 'Valor Realizado', type: 'line', data: [], color: '#00d084' },
      ],
      chartOptions: {
        chart: {
          type: 'line',
          stacked: false,
        },
        dataLabels: { enabled: false },
        stroke: { width: [1, 1, 4] },
        xaxis: { categories: [] },
        yaxis: [
          {
            title: { text: 'Q° de Clientes' },
            labels: { formatter: value => value.toFixed(0) },
          },
          {
            opposite: true,
            title: { text: 'Q° de Parcelas' },
            labels: { formatter: value => value.toFixed(0) },
          },
          {
            opposite: true,
            title: { text: 'Valor Realizado' },
            labels: { formatter: value => this.valorBr(value) },
          },
        ],
        tooltip: {
          y: {
            formatter: (val, opts) => {
              // Se for a serie "Valor Realizado"
              if (opts.seriesIndex === 2) {
                return this.valorBr(val)
              }
              return val
            },
          },
        },
        legend: { horizontalAlign: 'left' },
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedYear: 'graficos/getSelectedYear',
      selectedMonth: 'graficos/getSelectedMonth',
    }),
    chartReady() {
      return this.chartSeries[0].data.length > 0
    },
    cardTitle() {
      if (this.totalFaturamentoDia > 0) {
        return `Faturamento por Mês - ${this.valorBr(this.totalFaturamentoDia)}`
      }
      return 'Faturamento por Mês'
    },
  },
  watch: {
    selectedYear(newVal) {
      if (newVal) {
        this.fetchData()
      }
    },
    selectedMonth(newVal) {
      if (newVal) {
        this.fetchData()
      }
    },
  },
  created() {
    dayjs.locale('pt-br')
  },
  mounted() {
    if (this.selectedYear && this.selectedMonth) {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      if (!this.selectedYear || !this.selectedMonth) {
        return
      }

      this.isLoading = true
      this.totalFaturamentoDia = 0

      // Clear data arrays
      this.chartSeries.forEach(series => {
        series.data = []
      })
      this.chartOptions.xaxis.categories = []

      const payload = {
        ano: parseInt(this.selectedYear),
        mes: parseInt(this.selectedMonth),
      }

      axios.post('api/v1/credores/faturamento/geral/dia', payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          accept: 'application/json',
        },
      })
        .then(response => {
          const { data } = response

          if (data && data.length > 0) {
            data.forEach(item => {
              this.chartOptions.xaxis.categories.push(item.dia)
              this.chartSeries[0].data.push(item.total_clientes)
              this.chartSeries[1].data.push(item.total_parcelas)
              this.chartSeries[2].data.push(parseFloat(item.total))
              this.totalFaturamentoDia += parseFloat(item.total)
            })
            this.dadosGraficos = true
          } else {
            this.dadosGraficos = false
          }
        })
        .catch(() => {
          this.dadosGraficos = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    valorBr(valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(valor || 0)
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/pages/dashboard-ecommerce.scss';
  @import '@core/scss/vue/libs/chart-apex.scss';
</style>
